@if (!!topic) {
  <app-carousel #trainingCarousel [title]="getTopicTitle(topic)">
    <div class="topic">
      <div class="trainings d-flex">
        @for (training of topic.trainings; track trackTraining($index, training)) {
          <div #trainingCards class="d-flex card">
            <app-training-card [@cardsAnimation] [training]="training"></app-training-card>
          </div>
        }
      </div>
    </div>
  </app-carousel>
}
